import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-slides-carousel',
  cellSelector: '.js-slides-carousel-slide'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const cellElements = Array.from( element.querySelectorAll( settings.cellSelector ))
  if ( cellElements.length > 1 ) {
    initCarousel( element )
  }
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initCarousel( carouselEl ) {
  // eslint-disable-next-line no-unused-vars
  const carousel = new Flickity( carouselEl, {
    imagesLoaded: true,
    cellSelector: settings.cellSelector,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    autoPlay: true,
    pauseAutoPlayOnHover: true,
    wrapAround: true
  })
}
